// extracted by mini-css-extract-plugin
module.exports = {"comp":"O_comp__x23tq"};